const s = {};
export {
  s as default
};
//# sourceMappingURL=processingPaymentScreen.module.scss.js.map
